import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { SubstanceParentCodeEntity } from "../../../Data/MedicinalProductData/SubstanceParentCodeEntity";
import { ApprovedSubstanceAutoUploadEntity } from "./ApprovedSubstanceAutoUploadEntity";
import { DevelopmentSubstanceAutoUploadEntity } from "./DevelopmentSubstanceAutoUploadEntity";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceParentCode extends BaseNode {
    useHist: boolean = false;
    cloningNode: boolean = false;
    items: any;
    constructor(injector: Injector, cloningNode: boolean, model: any, parent:any) {

        super(injector,
            new SubstanceParentCodeEntity(injector, model),
            'Substance Parent EV Code');

        this.parent=parent;
        this.items = model;
        this.cloningNode = cloningNode;
        if (this.cloningNode) {
            return;
        }
        this.ioc!.get(Art57Section).generateNumColumValue(this);

        if (model.substancename){
            switch (model.parentTypeSubstance) {
                case 1:
                    this.children?.push(new DevelopmentSubstanceAutoUploadEntity(this.ioc!, `Development - ${model.parentEv_Code} - ${model.parentSubstanceName}`, this, {id: model.parentId},this.useHist ,false, false));
                    break;
                case 2:
                    this.children?.push(new ApprovedSubstanceAutoUploadEntity(this.ioc!, `Approved - ${model.parentEv_Code} - ${model.parentSubstanceName}`, this, {id: model.parentId},this.useHist, false, false));
                    break;
            }
        }

    }
    public getListItem(): any[] {
        return [this.data.model.sourcecode.name,this.data.model.parentSubstanceName];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeSubstanceParentCode = new TreeNodeSubstanceParentCode(this.ioc!,true,  this.items, newParent);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }    

}